import React from 'react'
import styled from 'styled-components'

const StyledFooter = styled.footer`
  flex-direction: column;
  display: flex;
  background-color: #2b2b2b;
  height: auto;
  padding: 10px 0;
  flex-wrap: wrap;
  color: #ffffff;
  font-size: 14px;
  text-align: center;

  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ul {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 1024px) {
      flex-direction: row;
    }
  }

  li {
    padding: 4px 8px 0;
  }

  a {
    color: #ffffff;
    text-decoration: none;
  }
`

const handleClick = e => {
  e.preventDefault()
  window.Didomi.preferences.show()
}

const FooterLi = () => (
  <StyledFooter>
    <span>Copyright © 2003-2021 Concept Multimédia</span>
    <ul>
      <li>
        <a href="https://www.logic-immo.com/conditions-generales-d-utilisation.html" title="">
          Conditions Générales d&apos;Utilisation
        </a>
      </li>
      <li>
        <a href="https://www.logic-immo.com/cgu-et-politique-de-confidentialite.html" title="">
          Politique Générale de Protection des Données
        </a>
      </li>
      <li>
        <a onClick={handleClick} href="/" title="Paramétrer mes cookies">
          Paramétrer mes cookies
        </a>
      </li>
    </ul>
  </StyledFooter>
)

export default FooterLi
